export default __webpack_public_path__ + "static/media/bodybag.95938c6f.webp";